<div class="mb-3 flex items-center">
  <app-search-input
    style="width: 100%"
    (searchDataEvent)="filtersStore.patchFilters({ query: $event })"
    [inputValue]="filtersStore.query()"
    inputWidth="100%"
    placeholder="Device Name, type & other"
  />
  <button
    class="test-toggle-table-filter-btn toggle-table-filter-btn ml-3"
    (click)="openDeviceFiltersBottomSheet()"
    [class.has-selected-filters]="hasSelectedFilters()"
  >
    <i class="icon-filter_Menu text-3xl"></i>
  </button>
</div>
